/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { type ReactNode } from 'react';

import { jsx } from '@compiled/react';

import { DetailsRow } from '../details-row';
import { DetailsSection } from '../details-section';

export interface SummarySectionRow {
	label: string;
	value: ReactNode;
}

export interface SummarySectionProps {
	rows: SummarySectionRow[];
	title: string;
}

export const SummarySection = ({ title, rows }: SummarySectionProps): JSX.Element | null => {
	if (!rows || rows.length === 0) {
		return null;
	}

	return (
		<DetailsSection title={title}>
			{rows.map(({ label, value }) => (
				<DetailsRow key={label} label={label} value={value} />
			))}
		</DetailsSection>
	);
};
